export default __webpack_public_path__ + "static/media/1_0036.0777ddcd.webp";